













import {
  defineComponent, ref, watch,
} from '@vue/composition-api';
import RdDictionarySelector from '@/components/base/inputs/RdDictionarySelector.vue';
import { UrlConstants } from '@/helpers/UrlConstants';
import { Driver } from '@/models/Driver';

export default defineComponent({
  name: 'RdEmployeeSelector',
  components: { RdDictionarySelector },
  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    label: {
      type: String,
      required: false,
      default: 'Выберите работника',
    },
    value: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: ['input'],
  setup: (props, { emit }) => {
    const url = `${UrlConstants.baseApi}/v1/drivers/select`;
    const type = Driver;
    const reactiveValue = ref(props.value);

    watch(reactiveValue, (current: any) => {
      emit('input', current);
    });

    return {
      reactiveValue,
      type,
      url,
    };
  },
});
